/*
 * Application
 */
jQuery(document).ready(function () {
    $('<div class="l-header__userinfo__popover"><div class="l-header__userinfo__popover__userinfo"></div></div>').hide().appendTo('.l-header__userinfo');
    var avatar = $('.l-header__userinfo__avatar').clone();
    $('img', avatar).attr('id', null);
    avatar.appendTo('.l-header__userinfo__popover__userinfo');
    $('.l-header__userinfo__name').clone().appendTo('.l-header__userinfo__popover__userinfo');
    $('.l-header__userinfo__logout').clone().appendTo('.l-header__userinfo__popover');

    $('#popover-userinfo').click(function () {
        if ($('.l-header__userinfo > .l-header__userinfo__name').css('display') === 'none') {
            if ($(this).attr('aria-expanded') === 'true') {
                $('.l-header__userinfo__popover').fadeOut(100);
                $(this).attr('aria-expanded', false);
            } else {
                $('.l-header__userinfo__popover').fadeIn(100);
                $(this).attr('aria-expanded', true);
            }
        }
    })

    $('.l-header__right__nav > a').clone().appendTo('.l-header__dropdown-menu');
    $('.c-main-menu-button').click(function () {
        if ($(this).attr('aria-expanded') === 'true') {
            $('.l-header__dropdown-menu').animate({height: 'toggle'}, 200);
            $(this).attr('aria-expanded', false);
        } else {
            $('.l-header__dropdown-menu').animate({height: 'toggle'}, 200);
            $(this).attr('aria-expanded', true);
        }
    })
});

$(document).tooltip({
    selector: "[data-toggle=tooltip]"
})

/*
 * Auto hide navbar
 */
jQuery(document).ready(function ($) {
    var $header = $('.navbar-autohide'),
        scrolling = false,
        previousTop = 0,
        currentTop = 0,
        scrollDelta = 10,
        scrollOffset = 150

    $(window).on('scroll', function () {
        if (!scrolling) {
            scrolling = true

            if (!window.requestAnimationFrame) {
                setTimeout(autoHideHeader, 250)
            } else {
                requestAnimationFrame(autoHideHeader)
            }
        }
    })

    function autoHideHeader() {
        var currentTop = $(window).scrollTop()

        // Scrolling up
        if (previousTop - currentTop > scrollDelta) {
            $header.removeClass('is-hidden')
        } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            // Scrolling down
            $header.addClass('is-hidden')
        }

        previousTop = currentTop
        scrolling = false
    }
});

function submitForm() {
    var fp1 = $("#contact_post_image1");
    var fp2 = $("#contact_post_image2");
    var fp3 = $("#contact_post_image3");
    var fp4 = $("#contact_post_image4");
    var items1 = fp1[0].files;
    var items2 = fp2[0].files;
    var items3 = fp3[0].files;
    var items4 = fp4[0].files;
    var fileSize1 = 0;
    var fileSize2 = 0;
    var fileSize3 = 0;
    var fileSize4 = 0;
    if (items1[0]) {
        fileSize1 = items1[0].size;
    }
    if (items2[0]) {
        fileSize2 = items2[0].size;
    }
    if (items3[0]) {
        fileSize3 = items3[0].size;
    }
    if (items4[0]) {
        fileSize4 = items4[0].size;
    }
    if($('#contact_post_text_body').val()
        && (fileSize1 <= 5242880
        && fileSize2 <= 5242880
        && fileSize3 <= 5242880
        && fileSize4 <= 5242880)) {
        $('form[name="contact-post-form"]').submit();
        $('#contact_post_text_body').val('');
        $('#contact_post_image1').val('');
        $('#contact_post_image2').val('');
        $('#contact_post_image3').val('');
        $('#contact_post_image4').val('');
        $('#contactPostImage2').hide();
        $('#contactPostImage3').hide();
        $('#contactPostImage4').hide();

    } else {
        $('form[name="contact-post-form"]').submit();
    }
}

var before = document.forms["contactPostForm"].elements["category_id"].selectedIndex;

function isTextBlank(s) {
    // キャンセルフラグをリセット
    delete_hidden('cancel', '1', 'contactPostForm');
    if ($('#text_body').val() || $('#title').val()) {
        var after = s.selectedIndex;
        if (confirm("件名と本文の内容が破棄されますがよろしいですか？")) {
            before = after;
        } else {
            // confirmキャンセルの場合はキャンセルフラグをバックエンドに渡す
            make_hidden('cancel', '1', 'contactPostForm');
            s.selectedIndex = before;
        }
    } else {
        before = s.selectedIndex;
    }
}

// input hidden作成
function make_hidden(name, value, formname) {
    var q = document.createElement('input');
    q.type = 'hidden';
    q.name = name;
    q.value = value;
    if (formname) {
        if ( document.forms[formname] == undefined ){
            console.error("ERROR: form " + formname + " is not exists.");
        }
        document.forms[formname].appendChild(q);
    } else {
        document.forms[0].appendChild(q);
    }
}
// input hidden破棄
function delete_hidden( name, value, formname ){
    var dom_obj_array = window.document.getElementsByName(name);
    for (var i=0; i<dom_obj_array.length; i++) {
        if ( dom_obj_array[i].value === value ) {
            element = dom_obj_array[i];
            element.parentNode.removeChild(element);
        }
    }
}
// フォームの二重送信防止
$('#create_contact_button').on('click', function () {
    $(this).css('pointer-events','none');
});
